/* A Hope & Fear handout sheet, built like the printed PDFs in the site's style:
   the tab with the frame name and sheet name, the sheet body, and the press line. */

import { ReactNode } from 'react';
import './HandoutSheet.css';

interface HandoutSheetProps {
  id: string;
  frame: string;
  title: string;
  className?: string;
  /** Shown beside the tab on wide screens (the doom track's intro). */
  aside?: ReactNode;
  children: ReactNode;
}

export default function HandoutSheet({ id, frame, title, className, aside, children }: HandoutSheetProps) {
  return (
    <section className={['hf-sheet', className].filter(Boolean).join(' ')} aria-labelledby={id}>
      <div className="hf-sheet__head">
        <h2 id={id} className="hf-sheet__tab">
          <span className="hf-sheet__frame">{frame}</span> <span className="hf-sheet__title">{title}</span>
        </h2>
        {aside}
      </div>
      {children}
      <p className="hf-sheet__footer">Daggerheart © Darrington Press 2026</p>
    </section>
  );
}
